import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlContainer, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NotificationTaskType } from 'src/app/classes';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-notification-task-preview',
  templateUrl: './notification-task-preview.component.html',
  styleUrls: ['./notification-task-preview.component.css']
})
export class NotificationTaskPreviewComponent implements OnInit {

  @Output() deleteEmitter: EventEmitter<void> = new EventEmitter();

  formGroup: FormGroup;

  subTitleMap = {
    'mail': (receiver: string) => receiver ? `E-Mail an ${receiver}` : 'E-Mail ohne Empfänger',
    'internal': (receiver: string) => {
      let user = this._dataService.users.find(x => x.id === receiver);
      return user ? `AMS Nachricht an ${user.userName}` : 'AMS Nachricht ohne Empfänger'
    }
  };
  subTitle: string;

  _subscriptions: Subscription[] = [];

  constructor(
    private _formBuilder: FormBuilder,
    private _dataService: DataService,
    private _controlContainer: ControlContainer
  ) { }

  delete() {
    this.deleteEmitter.emit();
  }

  ngOnInit(): void {
    this.formGroup = <FormGroup>this._controlContainer.control;
    this._subscriptions.push(this
      .formGroup
      .valueChanges
      .subscribe(() => this.updateSubTitle()));
    this.updateSubTitle();
  }

  updateSubTitle() {
    this.subTitle = this.typeControl.value === NotificationTaskType.EMail ? this.subTitleMap.mail(this.receiverControl.value): this.subTitleMap.internal(this.receiverControl.value);
  }

  get NotificationTaskType() {
    return NotificationTaskType;
  }

  // controls
  get attachementsControl(): FormArray {
    return this.formGroup.controls['attachements'] as FormArray;
  }
  get isDefaultNotificationControl(): AbstractControl {
    return this.formGroup.controls['isDefaultNotification'];
  }
  get contentControl(): AbstractControl {
    return this.formGroup.controls['content'];
  }
  get receiverControl(): AbstractControl {
    return this.formGroup.controls['receiver'];
  }
  get subjectControl(): AbstractControl {
    return this.formGroup.controls['subject'];
  }
  get typeControl(): AbstractControl {
    return this.formGroup.controls['type'];
  }

}
